import { getFileFromNwCDN } from './nw-cdn'

type BasePartner = {
  name: string
  imageUrl: string
  bio: string[]
  credential?: string

  enableProfileLandingPage?: boolean
}

type Partner = PartnerWithNoProfileLandingPage | PartnerWithProfileLandingPage

type PartnerWithNoProfileLandingPage = BasePartner & {
  enableProfileLandingPage: false
}

export type PartnerWithProfileLandingPage = BasePartner & {
  professionalBackground: string[]
  outsideTheOffice: string[]
  calendlyUrl: string
  specialties: string[]
  personalImageUrl: string
  professionalImageUrl: string
  heroImageUrl: string

  enableProfileLandingPage: true
}

export const getPartnerSlug = (name: string): string => name.replace(/\s/g, '-').toLowerCase()

export const PARTNERS: Array<Partner> = [
  {
    name: 'Ryan Sterling',
    credential: 'CFA®',
    imageUrl: getFileFromNwCDN('ryan-sterling@2x.webp'),
    bio: [
      'Founder and CEO of NerdWallet Wealth Partners',
      '20+ years of experience in wealth management',
      'MBA in Investment Management from Vanderbilt University',
      'A former child actor, he’s still a current SAG cardholder',
    ],
    enableProfileLandingPage: false,
  },
  {
    name: 'James Bashall',
    credential: 'CFP®, CPA',
    bio: [
      'More than 10 years in financial services, including six years in wealth management',
      'Master of Commerce in Finance from the University of Cape Town; Master of Science in Psychology from the University of East London',
      'Traveled to five continents and lived on three',
    ],
    imageUrl: getFileFromNwCDN('james-bashall@2x.webp'),
    enableProfileLandingPage: false,
  },
  {
    name: 'William Toczylowski',
    credential: 'CFP®',
    bio: [
      '10 years of wealth management experience from Capital Group, BNY Mellon Wealth Management, and Fidelity Institutional Asset Management',
      'BS in Finance and Economics from Providence College; Certificate in Financial Planning from New York University',
      'An avid golfer, hiker, and snowboarder',
    ],
    imageUrl: getFileFromNwCDN('william-toczylowski@2x-20251223.webp'),
    calendlyUrl: 'https://calendly.com/wtoczylowski-nerdwalletwealthpartners/30min',
    professionalBackground: [
      'Certified Financial Planner®',
      'One of the founding members of NerdWallet Wealth Partners.',
      'More than 10 years experience in wealth management at leading firms including Capital Group, BNY Mellon Wealth Management and Fidelity Institutional Asset Management.',
      'Earned a BS in finance and economics from Providence College and a Certificate in Financial Planning from New York University.',
    ],
    specialties: [
      'Financial Planning',
      'Investment Strategy',
      'Tax Strategy',
      'Retirement Planning',
      'Equity Compensation Planning',
    ],
    outsideTheOffice: [
      'I enjoy golf, hiking, snowboarding and playing chess',
      'I had a bit of an abnormal childhood in that my family moved 4 times across 4 different states by the time I was 15 years old.',
      'Favorite sports teams: US Mens/Womens Soccer, PC Friars Basketball, STL Cardinals, Chicago Blackhawks/Bulls, New England Patriots (go ahead and hate me)',
    ],
    enableProfileLandingPage: true,
    personalImageUrl: getFileFromNwCDN('william-toczylowski-personal-20260212.webp'),
    professionalImageUrl: getFileFromNwCDN('william-toczylowski-professional-20260212.webp'),
    heroImageUrl: getFileFromNwCDN('william-toczylowski@4x-20260323.webp'),
  },
  {
    name: 'Tracey Rinaldi',
    credential: 'J.D.',
    bio: [
      '18 years of experience in the financial industry, including eight years in wealth management',
      'Previously worked at Capital Group',
      'J.D. from the University at Buffalo Law School',
      'Passionate about helping women-led households and non-traditional families',
      'Never skips her 5 a.m. OrangeTheory class',
    ],
    imageUrl: getFileFromNwCDN('tracey-rinaldi@2x.webp'),
    calendlyUrl: 'https://calendly.com/trinaldi-nerdwalletwealthpartners/30min',
    professionalBackground: [
      '8 years in wealth management and 18 years in the financial industry',
      "Ambassador to Women in Financial Markets and Board Member of the Dean's Advisory Council for University at Buffalo Law School",
      'University at Buffalo Law School (J.D.) and University at Albany graduate (summa cum laude)',
    ],
    specialties: ['Women-led households', 'Non-traditional families', 'Financial and estate planning strategies'],
    outsideTheOffice: [
      'Mom of two kids, ages 9 and 6',
      'Even though I commute four times per week from Fairfield, CT to NYC for work, I still make it to my 5 a.m. class at OrangeTheory',
      'I love to read. Especially suspense, historical fiction, and the classics',
      "I'm a liaison to our town's Finance Committee and Board of Health as a member of the Board of Education",
    ],
    enableProfileLandingPage: true,
    personalImageUrl: getFileFromNwCDN('tracey-rinaldi-personal-20260212.webp'),
    professionalImageUrl: getFileFromNwCDN('tracey-rinaldi-professional-20260213.webp'),
    heroImageUrl: getFileFromNwCDN('tracey-rinaldi@4x-20260211.webp'),
  },
  {
    name: 'Michael Fishman',
    credential: 'CPA',
    imageUrl: getFileFromNwCDN('michael-fishman@2x-20251223.webp'),
    bio: [
      '10 years of experience in wealth management, including nine years at Goldman Sachs',
      "Master's in Personal Financial Planning from Bentley University",
      'Became a new dad in December 2025, but still fits in skiing, golf, and yoga when he can',
    ],
    enableProfileLandingPage: true,
    calendlyUrl: 'https://calendly.com/mfishman-nerdwalletwealthpartners/30min',
    professionalBackground: [
      'Certified Public Accountant',
      '10 years in Wealth Management, including 9+ years at Goldman Sachs',
      'Bentley University, Masters in Personal Financial Planning',
    ],
    specialties: ['Financial Planning', 'Investment Strategy', 'Retirement Planning'],
    outsideTheOffice: [
      "I'm a new dad, my son was born in December 2025",
      'I enjoy skiing, golf and yoga',
      'Favorite sports team: New England Patriots',
    ],
    personalImageUrl: getFileFromNwCDN('michael-fishman-personal-20260212.webp'),
    professionalImageUrl: getFileFromNwCDN('michael-fishman-professional-20260212.webp'),
    heroImageUrl: getFileFromNwCDN('michael-fishman@4x-20260211.webp'),
  },
  {
    name: 'Peter McGinley',
    credential: 'CFP®',
    imageUrl: getFileFromNwCDN('peter-mcginley@2x-20251223.webp'),
    bio: [
      '10 years in wealth management, previously worked at BNY',
      'B.S. in Finance from Providence College',
      'Former High School Ice Hockey Coach',
    ],
    enableProfileLandingPage: true,
    calendlyUrl: 'https://calendly.com/pmcginley-nerdwalletwealthpartners/30min',
    professionalBackground: [
      'Certified Financial Planner®',
      '10 years in Wealth Management, formerly worked at BNY',
      'Providence College',
    ],
    specialties: ['Financial Planning', 'Investment Strategy'],
    outsideTheOffice: [
      'Former High School Ice Hockey Coach and still play in my free time',
      'I have two dogs, Rosie and Frank',
      'Middle child with four siblings',
      'Favorite sports teams: New York Rangers, Knicks, Jets, Yankees',
    ],
    personalImageUrl: getFileFromNwCDN('peter-mcginley-personal-20260212.webp'),
    professionalImageUrl: getFileFromNwCDN('peter-mcginley-professional-20260212.webp'),
    heroImageUrl: getFileFromNwCDN('peter-mcginley@4x-20260211.webp'),
  },
  {
    name: 'Nick Churkovich',
    imageUrl: getFileFromNwCDN('nick-churkovich@2x-20251223.webp'),
    bio: [
      'Chartered Accountant (CA ANZ)',
      '8 years in wealth management, 3 years in accounting. Previously worked at Koda Capital and Deloitte.',
      'Monash University (Melbourne, AZ)',
      'Lived in three countries and visited 37',
    ],
    enableProfileLandingPage: true,
    calendlyUrl: 'https://calendly.com/nchurkovich-nerdwalletwealthpartners/30min',
    professionalBackground: [
      'Chartered Accountant (CA)',
      '8+ years of experience in wealth management, 3 years in accounting',
      'Previously worked as a Senior Associate at Koda Capital and an Analyst at Deloitte.',
    ],
    specialties: ['Financial Planning', 'Investment Strategy', 'Tax Planning'],
    outsideTheOffice: [
      'I enjoy film photography',
      'I recently moved to NYC and love finding new restaurants',
      "I've lived in 3 countries and visited 37",
      'Favorite sports teams: Collingwood Football Club (Australian Football), Las Vegas Raiders and San Antonio Spurs',
    ],
    personalImageUrl: getFileFromNwCDN('nick-churkovich-personal-20260212.webp'),
    professionalImageUrl: getFileFromNwCDN('nick-churkovich-professional-20260212.webp'),
    heroImageUrl: getFileFromNwCDN('nick-churkovich@4x-20260323.webp'),
  },
  {
    name: 'Josh Rubin',
    credential: 'CFP®',
    bio: [
      '4+ years experience in wealth management, previously worked at UBS and NewEdge Wealth',
      'B.S. at Syracuse University',
      'Ran the NYC marathon in under three hours',
    ],
    imageUrl: getFileFromNwCDN('josh-rubin@2x.webp'),
    enableProfileLandingPage: true,
    calendlyUrl: 'https://calendly.com/jrubin-nerdwalletwealthpartners/30min',
    professionalBackground: [
      'Certified Financial Planner (CFP®)',
      '4+ years of experience in Wealth Management.',
      'Previously worked at both UBS and NewEdge Wealth.',
      'Syracuse University',
    ],
    specialties: ['Financial Planning', 'Investment Strategy', 'Retirement Planning'],
    outsideTheOffice: [
      'I ran the NYC marathon in under 3 hours',
      'Member of Cure Epilepsy Charity Champions Program',
      'Favorite sports teams: New York Giants, Yankees, Knicks, and Syracuse Basketball/Football',
    ],
    personalImageUrl: getFileFromNwCDN('josh-rubin-personal-20260212.webp'),
    professionalImageUrl: getFileFromNwCDN('josh-rubin-professional-20260212.webp'),
    heroImageUrl: getFileFromNwCDN('josh-rubin@4x-20260211.webp'),
  },
  {
    name: 'Scott Brazina',
    bio: [
      'Level II Candidate in the Chartered Financial Analyst program',
      'Previously worked at Capital Group and Tough Mudder as Head of Events, where he oversaw the financial performance and delivery of over 60 events nationwide',
      'B.A. in Economics from Trinity College',
      'Proud Concord, MA native and stereotypical Boston sports fan',
    ],
    imageUrl: getFileFromNwCDN('scott-brazina@2x.webp'),
    enableProfileLandingPage: true,
    calendlyUrl: 'https://calendly.com/sbrazina-nerdwalletwealthpartners/30min',
    professionalBackground: [
      'Level II Candidate, Chartered Financial Analyst® Program',
      'Prior to joining NerdWallet Wealth Partners, I was an integral part of a team at Capital Group, managing $3+ billion in client assets while working closely with approximately 200 client relationships',
      'Earlier in my career, I was the head of events for Tough Mudder, where I was responsible for the financial performance and complete event delivery of 60+ events nationwide',
      'Trinity College',
    ],
    specialties: ['Financial Planning', 'Investment Strategy', 'Retirement Planning'],
    outsideTheOffice: [
      'I enjoy soccer and fitness',
      'I love spending time outdoors and have managed to get poison ivy 28 times in 6 years',
      'I grew up in Concord, MA and am your stereotypical Boston sports fan, I love the Red Sox, Patriots, Celtics, Bruins',
    ],
    personalImageUrl: getFileFromNwCDN('scott-brazina-personal-20260212.webp'),
    professionalImageUrl: getFileFromNwCDN('scott-brazina-professional-20260212.webp'),
    heroImageUrl: getFileFromNwCDN('scott-brazina@4x-20260211.webp'),
  },
  {
    name: 'Mike Letzter',
    bio: [
      '8+ years of experience in wealth management, previously worked at Rockefeller Capital Management and Bernstein',
      'B.S. in Economics from University of Wisconsin-Madison',
      "Didn't miss a single home football or basketball game in his four years in Madison",
    ],
    imageUrl: getFileFromNwCDN('mike-letzter@2x.webp'),
    enableProfileLandingPage: true,
    calendlyUrl: 'https://calendly.com/mletzter-nerdwalletwealthpartners/30min',
    professionalBackground: [
      '8+ years in Wealth Management',
      'Previously worked at Bernstein, a private wealth firm that managed $3 billion+ in client assets across approximately 300 relationships.',
      'Earlier in my career, I was with Rockefeller Capital Management, supporting the management of over $2 billion in assets for Ultra-High-Net-Worth clients and Private Foundations.',
      'University of Wisconsin-Madison',
    ],
    specialties: ['Financial Planning', 'Investment Strategy', 'Retirement Planning'],
    outsideTheOffice: [
      "I'm always looking for new restaurants to try in NYC",
      "I'm a lifelong Wisconsin Badgers fan. I didn't miss a single home football or basketball game in my four years at school.",
      'I have a miniature dachshund named Dewey',
    ],
    personalImageUrl: getFileFromNwCDN('mike-letzter-personal-20260212.webp'),
    professionalImageUrl: getFileFromNwCDN('mike-letzter-professional-20260212.webp'),
    heroImageUrl: getFileFromNwCDN('mike-letzter@4x-20260211.webp'),
  },
]
